// Stats.tsx
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts'
import { useStats } from './useStats'
import { useSelector } from 'react-redux'
import classes from './Stats.module.sass'
import { MetricsDetailed } from '../../../../../common/types/interfaces'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'

interface Props {
  metrics: MetricsDetailed | null
}

export const Stats = ({ metrics }: Props) => {
  const { granularity, setGranularity, chartData, hasData } = useStats(metrics)
  const darkTheme = useSelector(selectDarkTheme)

  if (!metrics) return null

  const axisColor = darkTheme ? '#888' : '#999'

  return (
    <div className={classes.container}>
      <div className={classes.title}>Статистика кластера</div>
      <div className={classes.tabs}>
        {(['day', 'week', 'month'] as const).map((g) => (
          <button
            key={g}
            className={granularity === g ? classes.active : ''}
            onClick={() => setGranularity(g)}
          >
            {g === 'day' ? 'Дни' : g === 'week' ? 'Недели' : 'Месяцы'}
          </button>
        ))}
      </div>
      {hasData ? (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" stroke={darkTheme ? '#333' : '#eee'} />
            <XAxis dataKey="date" stroke={axisColor} tick={{ fontSize: 10 }} />
            <YAxis stroke={axisColor} tick={{ fontSize: 10 }} />
            <Tooltip
              contentStyle={{
                background: darkTheme ? '#1f1f1f' : '#fff',
                border: `1px solid ${darkTheme ? '#333' : '#eee'}`,
                borderRadius: 4,
                fontSize: 12,
              }}
            />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="Визиты" stroke="#1890ff" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="Лиды" stroke="#faad14" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="Звонки" stroke="#ff4d4f" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="Заказы" stroke="#722ed1" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <div className={classes.empty}>Нет данных за период</div>
      )}
    </div>
  )
}